"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _UITextToolbarIconDropdown = _interopRequireDefault(require("UIComponents/editor/UITextToolbarIconDropdown"));

var ICON_PREFIX = 'align';

var AlignmentMenu =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(AlignmentMenu, _Component);

  function AlignmentMenu(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AlignmentMenu);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AlignmentMenu).call(this, props));
    _this.handleAlignmentClick = _this.handleAlignmentClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(AlignmentMenu, [{
    key: "handleAlignmentClick",
    value: function handleAlignmentClick(_ref) {
      var value = _ref.currentTarget.value;
      this.props.onChange(value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          alignOptions = _this$props.alignOptions,
          alignment = _this$props.alignment,
          defaultAlignment = _this$props.defaultAlignment,
          tooltip = _this$props.tooltip,
          dropdownClassName = _this$props.dropdownClassName;
      var options = Object.keys(alignOptions).map(function (key) {
        return {
          icon: ICON_PREFIX + "-" + alignOptions[key],
          value: alignOptions[key]
        };
      });
      return _react.default.createElement(_UITextToolbarIconDropdown.default, {
        defaultValue: defaultAlignment,
        onChange: this.handleAlignmentClick,
        options: options,
        tooltip: tooltip,
        value: alignment,
        dropdownClassName: dropdownClassName
      });
    }
  }]);
  return AlignmentMenu;
}(_react.Component);

exports.default = AlignmentMenu;
AlignmentMenu.propTypes = {
  onChange: _react.PropTypes.func.isRequired,
  defaultAlignment: _react.PropTypes.string.isRequired,
  alignment: _react.PropTypes.string,
  alignOptions: _react.PropTypes.object.isRequired,
  tooltip: _react.PropTypes.string,
  dropdownClassName: _react.PropTypes.string
};
module.exports = exports.default;